(function () {
  'use strict';

  var container = document.querySelector('[data-configurateur]');
  if (!container) return;

  var sectionSize = container.dataset.sectionSize || '3';
  var stepperSteps = container.querySelectorAll('.config-stepper__step');
  var configSections = container.querySelectorAll('[data-config-section]');
  var form = container.querySelector('.configurator-form');
  var labels = JSON.parse(container.dataset.configLabels || '{}');

  var completedSteps = {};
  var currentBlankHandle = '';
  var FADE_OUT_MS = 300;

  /* ============================================================
     STEP NAVIGATION
     - Previous section fades out, then new section slides in
     ============================================================ */

  function activateStep(step) {
    var nextSection = container.querySelector('[data-config-section="' + step + '"]');
    if (!nextSection) return;

    /* Find the currently active section */
    var currentActive = container.querySelector('.config-section.active');

    if (currentActive && currentActive !== nextSection) {
      /* Animate current section out */
      currentActive.classList.remove('active');
      currentActive.classList.add('leaving');

      currentActive.addEventListener('animationend', function handler() {
        currentActive.removeEventListener('animationend', handler);
        currentActive.classList.remove('leaving');
        /* display:none is applied by CSS (no .active, no .leaving) */

        /* Now show the next section */
        showNextSection(nextSection, step);
      });
    } else {
      showNextSection(nextSection, step);
    }
  }

  function showNextSection(section, step) {
    section.classList.add('active');
    updateStepper(step);

    setTimeout(function () {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }

  function updateStepper(activeStep) {
    var steps = ['intro', 'blank', 'handle'];
    if (sectionSize === '3') steps.push('guide');
    steps.push('resume');

    var activeIndex = steps.indexOf(activeStep);

    stepperSteps.forEach(function (el) {
      var stepName = el.dataset.step;
      var stepIndex = steps.indexOf(stepName);
      var badge = el.querySelector('.config-stepper__badge');
      var number = el.querySelector('.config-stepper__number');

      el.classList.remove('is-active', 'is-completed', 'is-future');

      if (completedSteps[stepName]) {
        el.classList.add('is-completed');
        if (badge) badge.hidden = false;
        if (number) number.textContent = '✓';
      } else if (stepIndex === activeIndex) {
        el.classList.add('is-active');
        if (badge) badge.hidden = true;
      } else {
        el.classList.add('is-future');
        if (badge) badge.hidden = true;
      }
    });
  }

  /* ============================================================
     PRODUCT FILTERING
     ============================================================ */

  function filterProducts(step, blankHandle) {
    var section = container.querySelector('[data-config-section="' + step + '"]');
    if (!section) return;
    section.querySelectorAll('.config-product-card').forEach(function (card) {
      var cardHandle = card.dataset.blankHandle;
      card.hidden = cardHandle && cardHandle !== blankHandle;
    });
  }

  /* ============================================================
     SELECTED CARD — Green button "Sélectionné"
     ============================================================ */

  function markSelectedCard(sectionName, selectedCard) {
    var sectionEl = container.querySelector('[data-config-section="' + sectionName + '"]');
    if (sectionEl) {
      sectionEl.querySelectorAll('.config-product-card.is-selected').forEach(function (c) {
        c.classList.remove('is-selected');
        var btn = c.querySelector('.product-card-showcase__cta .button');
        if (btn && btn.dataset.originalText) {
          btn.textContent = btn.dataset.originalText;
        }
      });
    }

    if (selectedCard) {
      selectedCard.classList.add('is-selected');
      var btn = selectedCard.querySelector('.product-card-showcase__cta .button');
      if (btn) {
        if (!btn.dataset.originalText) {
          btn.dataset.originalText = btn.textContent.trim();
        }
        btn.textContent = 'Sélectionné ✓';
      }
    }
  }

  /* ============================================================
     CONFIG STATE & RESUME TABLE
     ============================================================ */

  function updateConfig(element, productId, productName, productPrice) {
    var row = container.querySelector('.' + element + '-selected');
    if (row) {
      var elCell = row.querySelector('.element');
      var nameCell = row.querySelector('.name');
      var priceCell = row.querySelector('.price');

      if (elCell) elCell.textContent = labels['table_' + element] || element;
      if (nameCell) {
        nameCell.textContent = productName || labels.tip_included || '';
        nameCell.setAttribute('data-product-id', productId);
      }
      if (priceCell) priceCell.textContent = productPrice;
    }

    var input = form ? form.querySelector('input.' + element) : null;
    if (input) input.value = productId;

    /* Recalculate total */
    var priceCells = container.querySelectorAll('.config-resume-table tbody td.price');
    var total = 0;
    priceCells.forEach(function (cell) {
      var txt = cell.textContent.trim();
      var num = parseFloat(txt.replace('€', '').replace(/\s/g, '').replace(',', '.'));
      if (!isNaN(num)) total += num;
    });
    var totalCell = container.querySelector('tr.total .total-price');
    if (totalCell) totalCell.textContent = total.toFixed(2) + ' €';
  }

  /* ============================================================
     EVENT DELEGATION
     ============================================================ */

  container.addEventListener('click', function (e) {
    /* --- Stepper click: navigate to completed step --- */
    var stepEl = e.target.closest('.config-stepper__step');
    if (stepEl && stepEl.classList.contains('is-completed')) {
      activateStep(stepEl.dataset.step);
      return;
    }

    /* --- Product card selection --- */
    var card = e.target.closest('.config-product-card');
    var btn = e.target.closest('.product-card-showcase__cta a, .product-card-showcase__cta button');

    if (!card || !btn) return;
    if (card.dataset.outOfStock === 'true') return;
    e.preventDefault();

    var variantId = card.dataset.variantId;
    var productTitle = card.dataset.productTitle;
    var productPrice = card.dataset.productPrice;
    var section = card.closest('[data-config-section]');
    var step = section ? section.dataset.configSection : '';

    if (step === 'blank') {
      currentBlankHandle = card.dataset.productHandle;
      updateConfig('blank', variantId, productTitle, productPrice);
      markSelectedCard('blank', card);
      completedSteps.intro = true;
      completedSteps.blank = true;
      filterProducts('handle', currentBlankHandle);
      activateStep('handle');

    } else if (step === 'handle') {
      markSelectedCard('handle', card);
      completedSteps.handle = true;

      if (sectionSize === '3') {
        updateConfig('handle', variantId, productTitle, productPrice);
        filterProducts('guide', currentBlankHandle);
        activateStep('guide');
      } else {
        updateConfig('other', variantId, productTitle, productPrice);
        activateStep('resume');
      }

    } else if (step === 'guide') {
      markSelectedCard('guide', card);
      completedSteps.guide = true;

      updateConfig('guide', variantId, productTitle, productPrice);
      updateConfig('tip', card.dataset.tipVariantId || '', card.dataset.tipTitle || '', card.dataset.tipPrice || '');
      activateStep('resume');
    }
  });

  /* --- Start configuration button --- */
  var startBtn = container.querySelector('[data-start-config]');
  if (startBtn) {
    startBtn.addEventListener('click', function (e) {
      e.preventDefault();
      activateStep('blank');
    });
  }

  /* ============================================================
     CART & SAVE
     ============================================================ */

  var validateBtn = container.querySelector('[data-validate-config]');
  if (validateBtn) {
    validateBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!form) return;
      var formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Configurateur: cart error', err);
        });
    });
  }

  var saveBtn = container.querySelector('[data-save-config]');
  if (saveBtn) {
    saveBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!form || !window.cartSaver) return;

      var formData = new FormData(form);
      var obj = {};
      formData.forEach(function (value, key) {
        key.split('[').reduce(function (o, k, i, arr) {
          k = k.replace(']', '');
          if (i === arr.length - 1) { o[k] = value; return; }
          if (!o[k]) o[k] = {};
          return o[k];
        }, obj);
      });

      var payload = Object.keys(obj.items || {}).reduce(function (acc, key) {
        if (obj.items[key] && obj.items[key].id) {
          acc.push({
            quantity: parseInt(obj.items[key].quantity) || 1,
            variantId: parseInt(obj.items[key].id)
          });
        }
        return acc;
      }, []);

      window.cartSaver.createCart(payload).then(function (response) {
        if (response.status === 'success') {
          window.location.href = window.Shopify.routes.root + 'a/saved-carts/' + response.data.pubId;
        }
      });
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  var introSection = container.querySelector('[data-config-section="intro"]');
  if (introSection) introSection.classList.add('active');
  updateStepper('intro');
})();
